import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import {
	MORNINGSTAR_STYLE_BOX_CATEGORY_KEY,
	MORNINGSTAR_STYLE_BOX_COMPONENT_KEY,
} from '../MorningstarStyleBox.meta.js';

const rawCssPrefix = `
	display: grid;
	grid-template-rows: repeat(2, 1fr);
	grid-template-columns: repeat(3, 1fr);
	gap: 4px;
	text-align: center;
`;

export default InjectedStyledComponent(
	'div',
	MORNINGSTAR_STYLE_BOX_CATEGORY_KEY,
	MORNINGSTAR_STYLE_BOX_COMPONENT_KEY,
	['morningstarStyleBoxXAxis'],
	rawCssPrefix,
);
